// extracted by mini-css-extract-plugin
export default {"icon":"PasswordInput_icon__oUZph","icon--right":"PasswordInput_icon--right__+QQQT","icon--left":"PasswordInput_icon--left__R4NJG"};